import './style.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as reportActions from '../../redux/actions/report.action'
import NumberFormat from 'react-number-format'
import { RootReducers } from '../../redux/reducers'
import { HeaderBar } from '../../component/HeaderBar'
import { ChangeEvent, useEffect, useState } from 'react'
import { CSVLink, CSVDownload } from 'react-csv'
import errorAlert from '../../assets/images/error-alert.svg'
import {
  ConvertDateFormat,
  DisplayDateFormat,
  DisplayDateReportFormat,
  DisplayToThaiDateFormat,
  ReportDateFormat
} from '../../helpers/texthelper'
import { WatDatePicker } from '../../component/datePicker'
import { ETR_STATUS, SQD_REPORT } from '../../constants'
import {
  calculateAgingDay,
  calculateAmount,
  getPaymentObjectivesType,
  getStatusDate
} from '../../helpers/reportHelper'

import { ETRReport } from '../AgingReport/eTRReport'

export const CollectionReport = () => {
  const rightNow = new Date()
  const dispatch = useDispatch()
  const [getReport, setGetReport] = useState(SQD_REPORT.ETR_REPORT)
  const [formErrors, setFormErrors] = useState<any>({})
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const reportData = useSelector((state: RootReducers) => state.reportReducer)
  const [startDate, setstartDate] = useState(new Date())
  const [endDate, setendDate] = useState(new Date())
  const [eTRStatus, setETRStatus] = useState('')
  const [csvResult, setCsvResult] = useState<any>()
  const [isShowDownload, setIsShowDownload] = useState(false)
  const [reportName, setreportName] = useState(
    `report_etr_${loginState.account?.agentInfo.agentId}_${rightNow
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, '')}.csv`
  )

  const handleExportClick = () => {
    const reportParam = {
      email: loginState.account?.agentInfo.email,
      staff: loginState.account?.agentInfo.userName,
      startdate: ReportDateFormat(startDate),
      enddate: ReportDateFormat(endDate),
      status: eTRStatus
    }
    console.log(reportParam)
    console.log('getReport', getReport)
    switch (getReport) {
      case SQD_REPORT.ETR_REPORT:
        dispatch(reportActions.getETRReport(reportParam))
        break
      default:
        break
    }
    setIsShowDownload(true)
  }

  const handleWatDatePickerStartDate = (christDate: any, buddhistDate: any) => {
    setstartDate(christDate)
  }
  const handleWatDatePickerEndDate = (christDate: any, buddhistDate: any) => {
    setendDate(christDate)
  }

  useEffect(() => {
    switch (getReport) {
      case SQD_REPORT.ETR_REPORT:
        setCsvResult(ETRReport(reportData))
        break
      default:
        break
    }

    return () => {
      console.log('Prev value')
    }
  }, [reportData])

  return (
    <div>
      <HeaderBar>
        <div className="header-bar-text">e-TR Report</div>
      </HeaderBar>
      <div className="container">
        <div className="form-content">
          <form>
            <label className="report-label-input">
              <span>รายงาน</span>
              <select
                name="report"
                id="report"
                className={`field-input`}
                onChange={e => setGetReport(e.target.value)}
              >
                <option value={SQD_REPORT.ETR_REPORT}>eTR Report</option>
              </select>
            </label>
            <div className="report-label-input">
              <span>วันที่เริ่มต้น วัน/เดือน/ปี (พ.ศ.)</span>
              <WatDatePicker
                className={`amount-input ${formErrors.cheque_Date && 'error-border-validate'}`}
                name="startDate"
                onChange={handleWatDatePickerStartDate}
                dateFormat={'yyyy-MM-dd'}
                displayFormat={'DD/MM/YYYY'}
                clearable={false}
                // minDate={dayjs().add(-2, 'year')}
                // maxDate={dayjs().add(5, 'year')}
                disabled={false}
                readOnly={false}
                value={startDate}
                yearBoundary={99}
                inputStyle={formErrors.cheque_Date ? { borderColor: '#b30909' } : null}
              />
              {formErrors.startDate && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูลให้ถูกต้อง {DisplayToThaiDateFormat(new Date())}
                </div>
              )}
            </div>
            <div className="report-label-input">
              <span>วันที่สิ้นสุด วัน/เดือน/ปี (พ.ศ.)</span>
              <WatDatePicker
                className={`amount-input ${formErrors.cheque_Date && 'error-border-validate'}`}
                name="endDate"
                onChange={handleWatDatePickerEndDate}
                dateFormat={'yyyy-MM-dd'}
                displayFormat={'DD/MM/YYYY'}
                clearable={false}
                // minDate={dayjs().add(-2, 'year')}
                // maxDate={dayjs().add(5, 'year')}
                disabled={false}
                readOnly={false}
                value={endDate}
                yearBoundary={99}
                inputStyle={formErrors.cheque_Date ? { borderColor: '#b30909' } : null}
              />

              {formErrors.endDate && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูลให้ถูกต้อง {DisplayToThaiDateFormat(new Date())}
                </div>
              )}
            </div>
            <label className="report-label-input">
              <span>สถานะ e-TR</span>
              <select
                name="report"
                id="report"
                className={`field-input`}
                onChange={e => setETRStatus(e.target.value)}
              >
                <option value="">All</option>
                <option value={ETR_STATUS.NEW_ETR}>New</option>
                <option value={ETR_STATUS.CANCEL_ETR}>cancel</option>
                <option value={ETR_STATUS.SUBMITED_ETR}>submited</option>
                <option value={ETR_STATUS.SUCCESS_ETR}>sucess</option>
              </select>
            </label>
            <div className="search-staff-button-content">
              <button type="button" className="search-staff-button" onClick={handleExportClick}>
                ค้นหา
              </button>
            </div>
          </form>
          <div className="download-content">
            {reportData.isFetching && <div className="loader"></div>}
            {isShowDownload && csvResult && `ข้อมูลจำนวน ${csvResult.length - 1} รายการ`}

            {isShowDownload && csvResult && (
              <CSVLink className="download-link" data={csvResult} filename={reportName}>
                Download
              </CSVLink>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
